import { render, staticRenderFns } from "./DeclaracaoCartorioCadastro.vue?vue&type=template&id=731125a7&scoped=true&"
import script from "./DeclaracaoCartorioCadastro.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoCartorioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoCartorioCadastro.vue?vue&type=style&index=0&id=731125a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731125a7",
  null
  
)

export default component.exports